import React from 'react';
import './styles/stat.scss';
import { StatLabel } from './stat-label';
import Icon from '@bbkAdminUtils/icons/bbk-mini';

type StatProps = {
  value: string;
  label?: React.ReactNode;
};

export const StatContainerBBK = (props: StatProps) => {
  const { value, label } = props;
  return (
    <div className="stat-container-stacked">
      <div className="stat-container-top-row">
        <div className="stat-purple-container">
          <span className="stat-bbk-logo">{Icon.bbkMiniLogoTrans}</span>
          <span className="stat-value-small white-bg">{value}</span>
        </div>
      </div>
      <div className="stat-container-bottom-row">
        <StatLabel label={label} />
      </div>
    </div>
  );
};
